export default "__VITE_PUBLIC_ASSET__af90edb3__"